import React from 'react';
import PointTarget from 'react-point';
import NnSounds from '../music/NnSounds';
import NnKeyConstants from '../music/NnKeyConstants';
import '../assets/animation/Animations.scss';

const styles = {
  transition: 'all 0.5s ease-in',
};

const KEYDOWN_MS = 100; // minimium key press time in milliseconds (prevent doubles)

class NnPianoKey extends React.Component {
  node = React.createRef();

  constructor(props) {
    super(props);
    this.state = {
      octave: props.octave,
      active: props.active,
    };
    this.touched = false; // debounce onTouchStart event

    this.play = this.play.bind(this);
    this.stop = this.stop.bind(this);
    this.onMouseDown = this.onMouseDown.bind(this);
    this.onTouchStart = this.onTouchStart.bind(this);
  }

  render() {
    const { keyName, letters } = this.props;
    const noteCss = this.state.active ? 'active' : '';
    const keyNumber = NnKeyConstants.getKeyNumber(keyName);
    return (
      <div
        className={this.getClassNames(keyNumber)}
        style={{ ...styles, opacity: this.state.opacity }}
        ref={this.node}
        onMouseDown={this.onMouseDown}
        onMouseUp={this.onMouseUp}
        // moved the onTouchStart handker to componentDidMount to workaround
        // React bug per fix in https://github.com/facebook/react/issues/9809
        // onTouchStart={this.onTouchStart}
        onTouchEnd={this.onTouchEnd}
      ><div className={'BlinkKey'+ noteCss + ' blink'} id={"blink" + noteCss}></div>
        <div className={'flexbox'}>
            <span className={'arrow-img'}></span>
            <span className={'key-label ' + noteCss}>{this.getLabel(keyName, this.state.octave, letters)}</span>
        </div>
      </div>
    );
  }

  componentDidMount() {
    this.node.current.ontouchstart = this.onTouchStart;
  }

  onMouseDown(event) {
    this.startPlay();
  }
  onTouchStart(event) {
    event.preventDefault(); // prevent onMouseDown from also triggering
    this.startPlay();
  }

  startPlay() {
    if (!this.touched) {
      this.touched = true;
      this.timer = setTimeout(() => {
        this.touched = false;
      }, KEYDOWN_MS);
      this.play();
    }
  }

  stopPlay() {
    if (this.touched) {
      this.touched = false;
    }
  }

  getLabel(keyname, octave, displayLetters) {
    return NnKeyConstants.getDisplayName(keyname, octave, displayLetters);
  }

  componentWillUnmount() {
    clearTimeout(this.timer);
  }

  componentWillReceiveProps(nextProps) {      
    if (nextProps.octave !== this.state.octave || nextProps.active !== this.state.active) {
      this.setState({ active: nextProps.active, octave: nextProps.octave });
    }
  }

  // concatenate all state values that need to render as class names for this key
  getClassNames(keyNumber) {
    return [
      'piano-key',
      `key${keyNumber}`,
      this.props.keyName,
      this.props.black ? 'black' : 'white',
      this.state.active ? 'active' : '',
      'keyPress',
    ].join(' ');
  }

  play() {
    NnSounds.play(this.props.keyName, this.state.octave);
    this.props.onKeyPress(this.props.keyName, this.state.octave);
  }
  stop() {
    NnSounds.stop(this.props.keyName, this.state.octave);
  }

}
export default NnPianoKey;
